<template>
  <div class="card-form">
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @checkboxChange="(e) => (checkedRow = e)"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @batchPrint="batchPrint"
        @clearCheckboxRow="clearCheckboxRow"
        :checkedCount="checkedCount"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <ChooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :title="$l('INDEX.dialog_title_select_export_template') || '选择导出模版'"
      :templateQueryParams="{
        custCode: chooseTemplateOptions.custCode,
        endCustCode: chooseTemplateOptions.endCustCode,
        templateGroup: chooseTemplateOptions.templateGroup,
      }"
      :exportOptions="{
        params: chooseTemplateOptions.exportParams,
        checkUrl: chooseTemplateOptions.exportCheckUrl,
      }"
      @confirmClose="confirmClose"
      @clear="confirmClose"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import ChooseTemplate from '../choose-template'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, ChooseTemplate },
  data() {
    return {
      usePage: true,
      checkedRow: [],
      chooseTemplateOptions: {
        visible: false,
        templateGroup: 'admin-prebuilt-sample',
        exportCheckUrl: '',
        exportParams: {
          prebuiltStatus: '',
          listSampleCode: [],
        },
      },
    }
  },
  computed: {
    checkedCount() {
      return !this.checkedRow ? 0 : this.checkedRow.length
    },
  },
  methods: {
    async getData(form) {
      this.loading = true
      const res = await this.$api
        .prebuiltSampleBarcodeListApi({
          ...form,
          ...this.page,
        })
        .catch(() => (this.loading = false))
      this.loading = false
      if (!res) return
      this.setData(res)
    },
    clearCheckboxRow() {
      this.checkedRow = []
      this.$refs.main.clearCheckboxRow()
    },
    confirmClose() {
      this.chooseTemplateOptions.visible = false
      this.clearCheckboxRow()
      this.reload()
    },
    batchPrint(prebuiltStatus) {
      switch (prebuiltStatus) {
        case 'N':
          break
        case 'P':
          if (!this.checkedCount) {
            this.$message({
              message:
                this.$l('table_head_please_printed') || '请选择需要打印的数据',
              type: 'warning',
            })
            return
          }
          break
        case 'Y':
          this.$message({
            message:
              this.$l('tip_printing_not_allowed') || '已使用的标签，不允许打印',
            type: 'warning',
          })
          return
        default:
          return
      }
      const listSampleCode = this.checkedRow.map((item) => item.sampleCode)
      this.chooseTemplateOptions = {
        visible: true,
        templateGroup: 'admin-prebuilt-sample',
        exportCheckUrl: '/master/prebuilt/sample/barcode/printTime',
        exportParams: {
          prebuiltStatus,
          listSampleCode,
        },
      }
    },
  },
}
</script>
